import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import FilterAction from '../components/filterAction';
import { useEffect, useState } from 'react';
import TransactionList from '../components/TransactionList';
import forwarding from '../services/forwarding';
import { Table } from 'antd';
import { useHistory } from 'react-router-dom';

const BuskForwarding = () => {
  const breadcrumbList = [
    {
      tittle: '포워딩 업체 관리',
      url: ''
    },
    {
      tittle: '포워딩 업체 조회',
      url: ''
    }
  ];
  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: '업체명',
      dataIndex: 'name'
    },
    {
      title: '아이디',
      dataIndex: 'email'
    },
    {
      title: '국가',
      dataIndex: 'country'
    },
    {
      title: '소통 언어',
      dataIndex: 'locale'
    },
    {
      title: '주요 업무',
      dataIndex: 'description'
    },
    {
      title: '가입일',
      dataIndex: 'createdAt'
    }
  ];
  const [rowData, setRowData] = useState();
  const [date, setDate] = useState<[string, string]>();
  const [state, setState] = useState('');
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(1);
  const fromDt: string = (date && date[0]) || '';
  const toDt: string = (date && date[1]) || '';
  const [dataSource, setDataSource] = useState();
  const history = useHistory();

  const getTransactionList = async (
    page: number,
    fromDt: string,
    toDt: string,
    state: string,
    filterInput: string
  ) => {
    setLoading(true);
    const forwardingList = await forwarding.getForwardingList(
      page,
      state,
      filterInput,
      fromDt,
      toDt
    );
    setDataSource(forwardingList.data);
    setTotal(forwardingList.count);
  };
  useEffect(() => {
    getTransactionList(page, fromDt, toDt, state, input);
  }, [page]);

  useEffect(() => {
    if (page === 1) {
      getTransactionList(page, fromDt, toDt, state, input);
    } else {
      setPage(1);
    }
  }, [fromDt, toDt, state, input]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <FilterAction
          handleDateValue={setDate}
          handleStateValue={setState}
          handleInputValue={setInput}
        />
        <TransactionList
          rowData={rowData}
          count={total}
          page={page}
          fromDt={fromDt}
          toDt={toDt}
          filterState={state}
          filterInput={input}
        />
        <Table
          pagination={{
            total: total,
            current: page,
            pageSize: 10,
            onChange: (page, pageSize) => {
              setPage(page);
            }
          }}
          dataSource={dataSource}
          columns={columns}
          onRow={(record) => ({
            onClick: () => {
              history.push(`/admin/busk/forwarding/${record.id}`);
            }
          })}
        />
      </div>
    </div>
  );
};

export default BuskForwarding;
